import React, { useState } from 'react';
import Btn from '../../../../Components/Btn';
import ManualSortingItem from './ManualSortingItem';
import ModalManualSort from './ModalManualSort';
import PanelManualSorting from './PanelManualSorting';
import ShopifyManualSortingItem from './ShopifySorting/ShopifyManualSortingItem';

import {
	replaceId,
	demoteId,
	promoteId,
	pinId
} from '../../Ranking/utils';

export default function ManualSortingContainer({
	data,
	canUseShopifyManualSorting,
	shopifyCollectionWithPinnedProducts
}) {

	const [panelIsOpen, setpanelIsOpen] = useState(false);
	const [dimension, setdimension] = useState();

	function handleOpenManualSortPanel(dimensionToOpen) {
		if (!dimensionToOpen) {
			dimensionToOpen = canUseShopifyManualSorting ? pinId : promoteId;
		}
		setdimension(dimensionToOpen);
		setpanelIsOpen(true);
	}

	const filterBySign = (arrayToFilter, idToFilter) => {
		const itemTOtransform = arrayToFilter.filter(el => {
			return el.collationId === idToFilter;
		});
		let elementsToReturn = [];
		if (itemTOtransform.length !== 0) {
			elementsToReturn = [...itemTOtransform[0]['params'][0]['value']['stringValues']];
		}
		return elementsToReturn;
	};
	function getReplacesObj(arrayToFilter) {
		const uniqueItem = arrayToFilter.reduce((acc, curr) => {
			if (curr.collationId === replaceId) {
				const newObj = {
					...curr,
					idOld: curr.params.find(el => el.name === 'First Product Id').value.stringValues,
					idReplace: curr.params.find(el => el.name === 'Second Product Id').value.stringValues,
				};
				acc = [...acc, newObj];
			}

			return acc;
		}, []);

		return [...new Set(uniqueItem)];
	}
	return (
		<>
			<div className="collection_sidebar_block_title">Manual sorting</div>

			{canUseShopifyManualSorting &&
				<ShopifyManualSortingItem
					shopifyCollectionWithPinnedProducts={shopifyCollectionWithPinnedProducts}
					onClick={() =>
						handleOpenManualSortPanel(pinId)}
				/>
			}
			{!canUseShopifyManualSorting &&
				<ManualSortingItem
					name='Promoted products'
					list={filterBySign(data.transformations, promoteId)}
					handleOpenManualSortWithTabSelected={() =>
						handleOpenManualSortPanel(promoteId)}
				/>
			}
			<ManualSortingItem
				name='Demoted products'
				list={filterBySign(data.transformations, demoteId)}
				handleOpenManualSortWithTabSelected={() =>
					handleOpenManualSortPanel(demoteId)}
			/>
			<ManualSortingItem
				name='Swapped products'
				list={getReplacesObj(data.transformations)}
				handleOpenManualSortWithTabSelected={() =>
					handleOpenManualSortPanel(replaceId)}
			/>
			<Btn
				onClick={() => handleOpenManualSortPanel()}
				icon="fas fa-plus-circle"
				message="Add a manual sort"
				color="primary"
				style='outline'
				fullWidth={true}
			/>
			<ModalManualSort
				activeTab={dimension}
				setActiveTab={setdimension}
			/>
			{panelIsOpen &&
				<PanelManualSorting
					activeTab={dimension}
					setActiveTab={setdimension}
					panelIsOpen={panelIsOpen}
					dimension={dimension}
					handleClose={() => setpanelIsOpen(false)}
				/>
			}
		</>
	);
}
